<!-- <div class="row" *ngIf="isShowform"> -->
<div class="row align-items-center justify-content-center login-form-container no-gutters" *ngIf="isShowform">

  <div class="col-12"
    *ngIf="!isNewPasswordRequired && !isForgotPasswordClicked && !resetForgotPasswordCode && !showSmsMfaVerification">
    <div class="text-center mb-4">
      <span class="login-welcome maroon">Welcome To</span><br>
      <span class="login-heading">NissanConnect Commercial</span>
    </div>
    <div class="row align-items-center justify-content-center no-gutters">
      <div *ngIf="!isNewPasswordRequired" class="col-lg-4 col-md-4 col-sm-4 col-12">
        <form #loginForm="ngForm" novalidate (ngSubmit)="loginFormSubmit(loginForm)">
          <div class="form-group">
            <label>Username</label>
            <input type="email" class="form-control" [(ngModel)]="loginModal.username" name="username"
              #username="ngModel" required email>
            <small class="text-danger text-center" *ngIf="username.errors && loginForm.submitted">
              <p class="mb-0" *ngIf="username.errors.required">Email is required</p>
              <p class="mb-0" *ngIf="!username.errors.required">Please provide valid email</p>
            </small>
          </div>

          <div class="form-group">
            <label>Password</label>
            <input type="password" class="form-control" [(ngModel)]="loginModal.password" name="password"
              #password="ngModel" required>
            <small class="text-danger text-center" *ngIf="password.errors && loginForm.submitted">
              <p class="mb-0" *ngIf="password.errors.required">Password is required</p>
            </small>
            <div class="form-group maroon forgot-password text-right mt-1" (click)="forgotPasswordClicked()">
              <!-- <u> <i>Forgot password? </i> </u> -->
              Forgot password?
            </div>
          </div>
          <div class="text-center mt-4">
            <button type="submit" class="btn btn-primary border w-100">Login</button>
          </div>

        </form>
      </div>
    </div>
  </div>
  <div *ngIf="isNewPasswordRequired" class="col-12 align-items-center justify-content-center">
    <div class="col-6 offset-3">
      <h5 class="card-title mb-1">Choose a New Password</h5>
      <hr class="mt-0 mb-0">

      <div class="font12-400 mt-3 mb-2 text-muted">
        {{passwordRule}}
      </div>
      <form #resetPasswordForm="ngForm" novalidate (ngSubmit)="resetPasswordSubmit(resetPasswordForm)">
        <div class="form-group">
          <label>New Password</label>
          <!-- <input type="password" class="form-control" [(ngModel)]="resetPasswordModal.password" name="resetPassword"
            pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" #resetPassword="ngModel" required> -->
          <input type="password" class="form-control" [(ngModel)]="resetPasswordModal.password" name="resetPassword"
            pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[!@#$%^&*0-9a-zA-Z]{8,}" #resetPassword="ngModel" required>
          <small class="text-danger text-center" *ngIf="resetPassword.errors && resetPasswordForm.submitted">
            <p class="mb-0" *ngIf="resetPassword.errors.required">Password is required</p>
            <p class="mb-0" *ngIf="!resetPassword.errors.required">{{passwordFormatError}}</p>
          </small>
        </div>

        <div class="form-group">
          <label>Confirm Password</label>
          <input type="password" class="form-control" [(ngModel)]="resetPasswordModal.confirmPassword"
            name="confirmPassword" #confirmPassword="ngModel" required>
          <small class="text-danger text-center" *ngIf="confirmPassword.errors && resetPasswordForm.submitted">
            <p class="mb-0" *ngIf="confirmPassword.errors.required">Confirm Password is required</p>
          </small>
        </div>

        <div class="form-group maroon forgot-password text-right mt-3" (click)="resetUpdatePassword()">
          Go to Login
        </div>

        <div class="text-center mt-4">
          <!-- <div class="form-group maroon forgot-password">
            forgot password?
          </div> -->
          <button type="submit" class="btn btn-primary border">Submit</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Forgot password clicked -->
  <div *ngIf="isForgotPasswordClicked" class="col-12 align-items-center justify-content-center">
    <div class="col-6 offset-3">
      <form #forgotPasswordForm="ngForm" novalidate (ngSubmit)="forgotPasswordSubmit(forgotPasswordForm)">
        <div class="form-group">
          <label>Please enter your username/email to get the confirmation code</label>
          <input type="email" class="form-control mt-4" [(ngModel)]="forgotPasswordForm.username" name="username"
            #username="ngModel" required email>
          <small class="text-danger text-center" *ngIf="username.errors && forgotPasswordForm.submitted">
            <p class="mb-0" *ngIf="username.errors.required">Email is required</p>
            <p class="mb-0" *ngIf="!username.errors.required">Please provide valid email</p>
          </small>
        </div>
        <div class="form-group maroon forgot-password text-right mt-3" (click)="resetForgotPasswordFlow()">
          <!-- <u> Back to Login </u> -->Go to Login
        </div>
        <div class="text-center mt-4">
          <button type="submit" class="btn btn-primary border">Submit</button>
        </div>

      </form>
    </div>
  </div>

  <!-- Reset Forgot password code received -->
  <div *ngIf="resetForgotPasswordCode" class="col-12 align-items-center justify-content-center">
    <div class="col-6 offset-3">
      <h5 class="card-title mb-1">Choose a New Password</h5>
      <hr class="mt-0 mb-0">
      <div class="mt-3" *ngIf="confirmationCodeMessage"> {{confirmationCodeMessage}} </div>
      <!-- <div class="mt-3" > Change password confirmation is sent through EMAIL to rohit@gmail.com</div> -->
      <div class="font12-400 mt-4 mb-2 text-muted">
        {{passwordRule}}
      </div>

      <form #resetForgotPasswordForm="ngForm" autocomplete="off" novalidate
        (ngSubmit)="resetForgotPasswordSubmit(resetForgotPasswordForm)">
        <div class="form-group">
          <label>Confirmation Code</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="resetForgotPasswordModal.code"
            name="code" #code="ngModel" pattern="[0-9]{6}" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            maxlength="6" required>
          <small class="text-danger text-center" *ngIf="code.errors && resetForgotPasswordForm.submitted">
            <p class="mb-0" *ngIf="code.errors.required">Code is required</p>
            <p class="mb-0" *ngIf="!code.errors.required">Invalid Code</p>
          </small>
        </div>
        <div class="form-group">
          <label>New Password</label>
          <!-- <input type="password" class="form-control" [(ngModel)]="resetForgotPasswordModal.password"
            name="resetForgotPassword" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" #resetForgotPassword="ngModel"
            required> -->
          <input type="password" class="form-control" [(ngModel)]="resetForgotPasswordModal.password"
            name="resetForgotPassword" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[!@#$%^&*0-9a-zA-Z]{8,}"
            #resetForgotPassword="ngModel" autocomplete="new-password" required>
          <small class="text-danger text-center"
            *ngIf="resetForgotPassword.errors && resetForgotPasswordForm.submitted">
            <p class="mb-0" *ngIf="resetForgotPassword.errors.required">Password is required</p>
            <p class="mb-0" *ngIf="!resetForgotPassword.errors.required">{{passwordFormatError}}</p>
          </small>
        </div>

        <div class="form-group">
          <label>Confirm Password</label>
          <input type="password" class="form-control" [(ngModel)]="resetForgotPasswordModal.confirmPassword"
            name="confirmPassword" #confirmPassword="ngModel" autocomplete="new-password" required>
          <small class="text-danger text-center" *ngIf="confirmPassword.errors && resetForgotPasswordForm.submitted">
            <p class="mb-0" *ngIf="confirmPassword.errors.required">Confirm password is required</p>
          </small>
        </div>

        <div class="form-group maroon forgot-password mt-3">
          <span (click)="resendConfirmationCode()">Resend code</span>

          <span class="pull-right" (click)="onCancelResetForgotPasswordForm()">
            <!-- <u> Back to Login </u> -->Go to Login
          </span>
        </div>

        <div class="text-center mt-4">
          <button type="button" (click)="onCancelResetForgotPasswordForm()" class="btn btn-light border btn-80">Cancel</button>
          <button type="submit" class="btn btn-primary border ml-2 btn-80">Submit</button>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="showSmsMfaVerification" class="col-12">
    <sms-mfa-verification [smsMfaData]="smsMfaData" #smsMFA (resendMfaErrorEmitter)="resendMfaError($event)"></sms-mfa-verification>
  </div>

</div>

<app-confirmation-modal [modalId]="confirmationModalAttributes.modalId"
  [modalOpenButtonId]="confirmationModalAttributes.modalOpenButtonId"
  [modalCloseButtonId]="confirmationModalAttributes.modalCloseButtonId"
  [modalHeader]="confirmationModalAttributes.modalHeader" [content]="confirmationModalAttributes.content"
  [submitButtonClass]="confirmationModalAttributes.submitButtonClass"
  [cancelButtonClass]="confirmationModalAttributes.cancelButtonClass" (saveEmitter)="onConfirm($event)"
  (cancelEmitter)="onConfirmCancel($event)" #confirmationModal></app-confirmation-modal>